import script from "./MenuNoticiasView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuNoticiasView.vue?vue&type=script&setup=true&lang=js"

import "./MenuNoticiasView.vue?vue&type=style&index=0&id=e48bda5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e48bda5a"]])

export default __exports__